import * as React from 'react';
import { Technology } from '@shapeable/copper-connect-types';

export const TechnologiesContext = React.createContext<Technology[]>([]);
export const TechnologiesProvider = TechnologiesContext.Provider;